module.exports = __webpack_public_path__ + "img/circle-right.aaed406c.png";